import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  spotsFull: {
    id: 'yield-management.schedule-list.schedule-list-item.is-spots-full',
    defaultMessage: 'Spots Full',
  },
  almostFull: {
    id: 'yield-management.schedule-list.schedule-list-item.is-almost-full',
    defaultMessage: 'Almost Full',
  },
  smartSpotOn: {
    id: 'yield-management.schedule-list.schedule-list-item.smart-spot-on',
    defaultMessage: 'SmartSpot is on for this session',
  },
  addSpotButton: {
    id: 'yield-management.schedule-list.schedule-list-item.add-spot-button',
    defaultMessage: 'Add 1 Spot',
  },
  isCancelled: {
    id: 'yield-management.schedule-list.schedule-list-item.is-canceled',
    defaultMessage: 'Canceled',
  },
  isDisabled: {
    id: 'yield-management.schedule-list.schedule-list-item.is-disabled',
    defaultMessage: 'Disabled',
  },
  reservationsStopped: {
    id: 'yield-management.schedule-list.schedule-list-item.reservations-stopped',
    defaultMessage: 'Bookings Paused',
  },
  opportunityButton: {
    id: 'yield-management.schedule-list.schedule-list-item.opportunity-button',
    defaultMessage: 'Add {recommendation, plural, one {# Spot} other {# Spots}}',
  },
  durationMinutes: {
    id: 'yield-management.schedule-list.schedule-list-item.duration-minutes',
    defaultMessage: '{duration, number} Minutes',
  },
  noInstructor: {
    id: 'yield-management.schedule-list.schedule-list-item.no-instructor',
    defaultMessage: 'No Staff Specified',
  },
  allBookings: {
    id: 'yield-management.schedule-list.schedule-list-item.all-bookings',
    defaultMessage: '{totalBooked} / {maxCapacity}',
  },
  cpAllocation: {
    id: 'yield-management.schedule-list.schedule-list-item.cp-allocation',
    defaultMessage: '{classpassBooked} / {classpassTotal}',
  },
  hasDemandTooltip: {
    id: 'yield-management.schedule-list.schedule-list-item.has-demand-tooltip',
    defaultMessage:
      '{value, plural, one {<b># client</b> is waiting for a spot} other {<b># clients</b> are waiting for spots}} ',
  },
});
